<template>
  <RecycleScroller
    ref="recycleScroller"
    :items="allPollingEvents"
    :item-height="150"
    class="scroller"
    page-mode
  >
    <VCard
      slot-scope="{ item }"
      :to="item.listChoicesRoute"
    >
      <VContainer
        fluid
        grid-list-lg
      >
        <VLayout
          fill-height
          align-center
          justify-center
          row
          wrap
        >
          <VFlex xs12>
            <VCard
              color="blue-grey darken-2"
              class="white--text"
            >
              <VLayout>
                <!--<v-flex-->
                <!--xs5-->
                <!--sm3-->
                <!--md3-->
                <!--lg2-->
                <!--&gt;-->
                <!--<v-img-->
                <!--src="https://cdn.vuetifyjs.com/images/cards/foster.jpg"-->
                <!--height="100px"-->
                <!--contain-->
                <!--/>-->
                <!--</v-flex>-->
                <VFlex
                  xs7
                  sm9
                  md9
                  lg10
                >
                  <VCardTitle primary-title>
                    <VLayout
                      row
                      wrap
                    >
                      <VFlex xs12>
                        <div class="headline">
                          {{ item.name }} ({{ item.eventDate }})
                        </div>
                      </VFlex>
                      <VFlex xs12>
                        <div class="description">
                          Choices: ({{ item.pollingEventChoice.length }})
                        </div>
                      </VFlex>
                    </VLayout>
                  </VCardTitle>
                </VFlex>
              </VLayout>
            </VCard>
          </VFlex>
        </VLayout>
      </VContainer>
    </VCard>
  </RecycleScroller>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PollingEventTable',
  computed: {
    ...mapGetters({
      allPollingEvents: 'polling/getAllPollingEvents'
    })
  },
  methods: {
    tempRemove (event) {
      this.items.splice(event.index, 1)
    }
  }
}

</script>

<style scoped>

</style>
